import Loading from "./Loading.presenter";

export default Loading;
